import { useMemo } from 'react';
import { useAuth } from 'react-oidc-context';

import type { MethodType, IPaymentMethod } from '@endeavour/payment-integration';

import { usePromiseValue } from '../../shared/hooks/use-promise-value';
import { useProviderIntegration } from '../util/provider-context';

export function useGetPaymentMethod(
    paymentType: MethodType,
    paymentMethod?: IPaymentMethod | IPaymentMethod[],
    integrationId?: string,
) {
    const integration = useProviderIntegration();
    const auth = useAuth();
    const userProfileId = auth?.user?.profile.user_profile_id as string;

    const methodDetails = usePromiseValue(
        useMemo(() => {
            if (!userProfileId || !paymentMethod) {
                return;
            }

            return integration.getMethods(
                {
                    configuration: {
                        userProfileId,
                    },
                    type: paymentType,
                    methods: Array.isArray(paymentMethod) ? paymentMethod : [paymentMethod],
                },
                integrationId,
            );
        }, [userProfileId, integrationId, integration, paymentMethod, paymentType]),
    );

    return useMemo(
        () => ({
            methodDetails,
        }),
        [methodDetails],
    );
}
